import Modal from 'react-bootstrap/Modal';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { faArrowUpRightFromSquare, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CardName from "../../../components/global/CardName";
import CardDescription from '../../../components/card/CardDescription';
import CompanyModalRemove from "./CompanyModalRemove";
import CompanyModalArchive from "./CompanyModalArchive";
import CompanyModalArchiveCancel from "./CompanyModalArchiveCancel";
import CompanyModalRemoveExt from './CompanyModalRemoveExt';
import ButtonAction from '../../../components/global/ButtonAction';
import ErrorAdd from '../../../util/ErrorAdd';
import { useSelector } from 'react-redux';

function CompanyModal({ show, onHide, model }) {

  const stateSize = useSelector((state) => state.size);//Размеры окна
  const refHeader = useRef(null);//Шапка карточки
  const refFooter = useRef(null);//Footer карточки
  const [hightBody, setHightBody] = useState(0);
  const [minHightBody, setMinHightBody] = useState(0);

  useEffect(() => {

    setMinHightBody(stateSize.windowHeight / 2.5)
    if (stateSize.desktop !== true) {
      setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - refFooter.current.offsetHeight - 120)
    }
    if (stateSize.desktop === true) {
      const w = stateSize.windowHeight - refHeader.current.offsetHeight - 150;
      setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - 150)
    }
  }, [refHeader, refFooter, stateSize, model, hideDescription, hideName]);

  const [modalRemoveShow, setModalRemoveShow] = useState(false);
  const [modalRemoveExtShow, setModalRemoveExtShow] = useState(false);
  const [modalArchiveShow, setModalArchiveShow] = useState(false);
  const [modalArchiveCancelShow, setModalArchiveCancelShow] = useState(false);

  const [hideName, setHideName] = useState(false);
  const [logName, setLogName] = useState(null);
  const [loadingName, setLoadingName] = useState(false);

  function updateName(val) {
    setLogName(null);
    setLoadingName(true);

    axios.post('/api_main/company/updateName', { ID_Company: model.ID, Name: val })
      .then((res) => {
        if (res.data.Status === 1) {
          setHideName(true);
          setLoadingName(false);
        }
        else {
          setLogName(res.data.Error);
          setLoadingName(false);
        }
      })
      .catch((err) => {
        setLogName('Неизвестная ошибка!');
        setLoadingName(false);
        ErrorAdd(err, window.location.href);
      });
  }

  const [hideDescription, setHideDescription] = useState(false);
  const [logDescription, setLogDescription] = useState(null);
  const [loadingDescription, setLoadingDescription] = useState(false);
  function updateDescription(val) {
    setLoadingDescription(true);
    setLogDescription(null);

    axios.post('/api_main/company/updateDescription', { ID_Company: model.ID, Description: val })
      .then((res) => {
        if (res.data.Status === 1) {
          setLoadingDescription(false);
          setHideDescription(true);
        }
        else {
          setLogDescription(res.data.Error);
          setLoadingDescription(false);
        }
      })
      .catch((err) => {
        setLogDescription('Неизвестная ошибка!');
        setLoadingDescription(false);
        ErrorAdd(err, window.location.href);
      });

  }

  return (
    <>
      {modalRemoveShow === true && (
        <CompanyModalRemove show={modalRemoveShow} onHide={() => setModalRemoveShow(false)} onHideLabel={() => onHide()} idCompany={model.ID} name={model.Name} />
      )}
      {modalRemoveExtShow === true && (
        <CompanyModalRemoveExt show={modalRemoveExtShow} onHide={() => setModalRemoveExtShow(false)} onHideLabel={() => onHide()} idCompany={model.ID} name={model.Name} />
      )}
      {modalArchiveShow === true && (
        <CompanyModalArchive show={modalArchiveShow} onHide={() => setModalArchiveShow(false)} onHideLabel={() => onHide()} idCompany={model.ID} name={model.Name} />
      )}
      {modalArchiveCancelShow === true && (
        <CompanyModalArchiveCancel show={modalArchiveCancelShow} onHide={() => setModalArchiveCancelShow(false)} onHideLabel={() => onHide()} idCompany={model.ID} name={model.Name} />
      )}
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Body className='' >
          <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
          <div className="row" >
            <div className="col-lg-7" >
              <div className="mb-3" ref={refHeader}>
                <CardName name={model.Name} onlyRead={model.External} updateHandler={updateName} placeholder='Название компании...' hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                {model.External === true && (<small className='mt-0 text-uppercase fw-bold opacity-50'><FontAwesomeIcon icon={faArrowUpRightFromSquare} className='mr-5' /> Внешняя компания</small>)}
              </div>
              <div className="mb-3" style={{ minHeight: minHightBody, maxHeight: hightBody, overflow: 'auto' }}>
                <CardDescription text={model.Description} rows={5} placeholder="описание..." updateHandler={updateDescription} loading={loadingDescription} log={logDescription} hide={hideDescription} setHide={setHideDescription} />
              </div>
            </div>
            <div className="col-lg-5 text-center" ref={refFooter} style={{ height: '85px' }}>
              <div className="card-block-title">Действия</div>
              {
                model.External === false ? (
                  model.ID_Status === 1 ?
                    (
                      <>
                        <div className="mt-10"><ButtonAction typeBtn='archive' onClick={() => setModalArchiveShow(true)} /></div>
                      </>
                    )
                    :
                    (
                      <>
                        <div className="mt-10"><ButtonAction typeBtn='cancel' textBtn='Отмена архивирования' onClick={() => setModalArchiveCancelShow(true)} /></div>
                      </>
                    )
                )
                  :
                  (
                    <div className="mt-10"><ButtonAction typeBtn='remove' onClick={() => setModalRemoveExtShow(true)} /></div>
                  )
              }
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default CompanyModal;
